// userService.js
import { getAllUsers, getContactPersons, getRoleBasedUsers, loginUser, updateUserById } from "./controllers/userController.js";



export const handleGetAllUsers = async (options = {}) => {
  const { users, lastVisible, firstVisible } = await getAllUsers(options);

  const formattedUsers = users.map(user => {
    const timestamp = user.createdTimestamp?.toDate();
    const formattedDate = timestamp
      ? new Date(timestamp).toLocaleString("en-GB", {
          timeZone: "Asia/Kolkata",
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
      : "N/A";

    return {
      id: user.id,
      name: user.name,
      phoneNumber: user.phoneNumber,
      status: user.status,
      createdDate: formattedDate,
      email: user.emailId,
      role: user.role,
    };
  });

  return {
    users: formattedUsers,
    firstDoc: firstVisible.id,

    lastDoc: lastVisible.id,
  };
};

export const handleUpdateUserById = async (id, updatedData) => {
  await updateUserById(id, updatedData);
};

export const handleLoginUser = async (data) => {
  const userData = await loginUser(data); 


  return {
    message: "Login successful",
    user: {
      email: userData.emailId,
      role: userData.role,
      status: userData.status,
      name: userData.name,
      phoneNumber: userData.phoneNumber,
      uid: userData.uid,
    },
  };
};

export const handleGetRoleBasedUsers = async () =>{
  const users = await getRoleBasedUsers();
  return users
  
};

export const handleGetContactPersons = async ()=>{
  const contactPersons = await getContactPersons()
  return contactPersons
}
